import {
  FileArchive, FileImage, FileSpreadsheet, FileText, File as FichierGenerique, Presentation,
} from 'lucide-react';

/* Ce qu'un fichier est, d'après son extension — jamais d'après son contenu.

   `apercu` dit comment la plateforme l'affiche ; le type MIME est fixé ici
   et non lu dans la réponse : un .txt qui contiendrait du HTML reste du
   texte. Word, Excel et PowerPoint n'ont pas d'aperçu : le navigateur ne
   sait pas les lire, et les services en ligne qui le savent exigeraient
   d'envoyer le fichier chez un tiers. */
const FAMILLES = {
  pdf: { libelle: 'PDF', Icone: FileText, teinte: 'bg-[var(--alerte-fond)] text-[var(--alerte)]', apercu: 'pdf', mime: 'application/pdf' },
  png: { libelle: 'Image', Icone: FileImage, teinte: 'bg-[var(--info-fond)] text-[var(--text-bold)]', apercu: 'image', mime: 'image/png' },
  jpg: { libelle: 'Image', Icone: FileImage, teinte: 'bg-[var(--info-fond)] text-[var(--text-bold)]', apercu: 'image', mime: 'image/jpeg' },
  jpeg: { libelle: 'Image', Icone: FileImage, teinte: 'bg-[var(--info-fond)] text-[var(--text-bold)]', apercu: 'image', mime: 'image/jpeg' },
  gif: { libelle: 'Image', Icone: FileImage, teinte: 'bg-[var(--info-fond)] text-[var(--text-bold)]', apercu: 'image', mime: 'image/gif' },
  webp: { libelle: 'Image', Icone: FileImage, teinte: 'bg-[var(--info-fond)] text-[var(--text-bold)]', apercu: 'image', mime: 'image/webp' },
  txt: { libelle: 'Texte', Icone: FileText, teinte: 'bg-[var(--bg-main)] text-[var(--text-bold)]', apercu: 'texte', mime: 'text/plain' },
  csv: { libelle: 'CSV', Icone: FileSpreadsheet, teinte: 'bg-[var(--vert-pale)] text-[var(--vert-fonce)]', apercu: 'texte', mime: 'text/csv' },
  xls: { libelle: 'Excel', Icone: FileSpreadsheet, teinte: 'bg-[var(--vert-pale)] text-[var(--vert-fonce)]' },
  xlsx: { libelle: 'Excel', Icone: FileSpreadsheet, teinte: 'bg-[var(--vert-pale)] text-[var(--vert-fonce)]' },
  doc: { libelle: 'Word', Icone: FileText, teinte: 'bg-[var(--info-fond)] text-[var(--text-bold)]' },
  docx: { libelle: 'Word', Icone: FileText, teinte: 'bg-[var(--info-fond)] text-[var(--text-bold)]' },
  ppt: { libelle: 'PowerPoint', Icone: Presentation, teinte: 'bg-[var(--attention-fond)] text-[var(--attention)]' },
  pptx: { libelle: 'PowerPoint', Icone: Presentation, teinte: 'bg-[var(--attention-fond)] text-[var(--attention)]' },
  zip: { libelle: 'Archive', Icone: FileArchive, teinte: 'bg-[var(--bg-main)] text-[var(--text-muted)]' },
};

const INCONNU = { libelle: 'Fichier', Icone: FichierGenerique, teinte: 'bg-[var(--bg-main)] text-[var(--text-muted)]' };

export function extensionDe(doc) {
  if (doc?.extension) return doc.extension.toLowerCase();
  const nom = doc?.fichier_url || doc?.nom_fichier || '';
  const m = /\.([a-z0-9]+)(?:\?.*)?$/i.exec(nom);
  return m ? m[1].toLowerCase() : '';
}

export function typeDeFichier(doc) {
  const ext = extensionDe(doc);
  return { extension: ext, ...(FAMILLES[ext] || INCONNU) };
}

export function TuileFichier({ doc, taille = 'md' }) {
  const t = typeDeFichier(doc);
  const { Icone } = t;
  const dims = taille === 'lg' ? 'w-12 h-12' : 'w-10 h-10';
  return (
    <span className={`${dims} shrink-0 rounded-pastille grid place-items-center relative ${t.teinte}`} aria-hidden="true">
      <Icone className={taille === 'lg' ? 'w-6 h-6' : 'w-5 h-5'} />
      {t.extension && (
        <span className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 px-1 rounded-[4px] bg-[var(--bg-card)] border border-[var(--border)] text-[8.5px] font-bold uppercase leading-[13px] text-[var(--text-bold)]">
          {t.extension.slice(0, 4)}
        </span>
      )}
    </span>
  );
}
